import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component<IssueMixin>({})
export default class IssueMixin extends Vue {}
